<template>
  <el-card>
    <div
      slot="header"
      class="clearfix"
    >
      <span>Képviselői befizetések</span>
      <el-button
        style="float: right; margin-top: -5px;"
        type="success"
        size="small"
        @click="$router.replace('/representative-processes/payments/add')"
        icon="el-icon-plus"
        v-can="'representativepayment.create'"
      >
        Új befizetés
      </el-button>
    </div>
    <div v-loading="loading" style="min-height: 81px;">
      <table-filter
        v-if="filterConfig"
        :config="filterConfig"
        action="representativePayment/fetchAll"
      />
    </div>
    <representative-payment-list/>
    <template v-if="$route.meta.showAddRepresentativePaymentDialog">
      <representative-payment-dialog
        type="add"
      />
    </template>
    <template v-if="$route.meta.showUpdateRepresentativePaymentDialog">
      <representative-payment-dialog
        :representative-payment-id="$route.params.id"
        type="update"
      />
    </template>
  </el-card>
</template>

<script>
import representativePaymentList from '../../components/representativeProcesses/representativePayments/List';
import representativePaymentDialog from '../../components/representativeProcesses/representativePayments/Dialog';
import TableFilter from '../../components/TableFilter';

export default {
  components: {
    representativePaymentList,
    representativePaymentDialog,
    TableFilter,
  },
  data() {
    return {
      loading: false,
      filterConfig: null,
    };
  },
  async mounted() {
    this.loading = true;
    await this.setConfig();
    this.loading = false;
  },
  methods: {
    async setConfig() {
      let users = this.$store.getters['user/users'];
      if (!users.length) {
        await this.$store.dispatch('user/fetchAll');
        users = this.$store.getters['user/users'];
      }
      this.filterConfig = [
        {
          type: 'select',
          name: 'user',
          options: users,
          label: 'Képviselő',
          labelCallback: user => user && `${user.last_name} ${user.first_name} (@${user.username})` || '',
          valueKey: 'id',
          defaultSearch: true,
        },
        {
          type: 'dateRange',
          name: 'payment_date',
          label: 'Befizetés időpontja',
        },
        {
          type: 'text',
          name: 'comment',
          label: 'Megjegyzés',
        },
        {
          type: 'text',
          name: 'amount',
          label: 'Összeg',
        },
      ];
    },
  },
};
</script>
